import OrderDetailTotalPrice from './OrderDetailTotalPrice.styled';

export default OrderDetailTotalPrice;
